export default "__VITE_ASSET__DTlWEhIn__"